import axios from 'axios';
import {PRICE_VERSION_VARIATION_ENDPOINT} from '../../endpoints';

export async function getAllModels({search}){
  try{
    let data = await axios.get(`${PRICE_VERSION_VARIATION_ENDPOINT}/${search}`).then(result=>result.data);
    return {data: data.data, years: data.years}
  }catch(error){
    throw new Error(error)
  }
}